import { Alert, Grid } from '@mui/material'

import {
  useGetBidNegotiationHistogramQuery,
  useGetBidNegotiationOverviewQuery,
} from 'generated/graphql'

import { NegotiatedJobsKpiCard } from './NegotiatedJobsKpiCard'
import { NegotiationOutcomeTiles } from './NegotiationOutcomeTiles'
import { NegotiationOverviewHistoryNote } from './NegotiationOverviewHistoryNote'
import { PriceDeltaHistogramCard } from './PriceDeltaHistogramCard'
import { useNegotiationOverviewQueryInput } from './useNegotiationOverviewQueryInput'

export const NegotiationOverviewCards = () => {
  const { start, hasValidRange, isCustom, input } = useNegotiationOverviewQueryInput()

  const queryOptions = {
    variables: { input },
    skip: !hasValidRange,
    notifyOnNetworkStatusChange: true,
    nextFetchPolicy: 'cache-and-network' as const,
  }

  const overview = useGetBidNegotiationOverviewQuery(queryOptions)
  const histogram = useGetBidNegotiationHistogramQuery(queryOptions)

  const overviewData =
    overview.data?.bidNegotiationOverview ?? overview.previousData?.bidNegotiationOverview
  const histogramData =
    histogram.data?.bidNegotiationHistogram ?? histogram.previousData?.bidNegotiationHistogram

  const hasError = overview.error || histogram.error

  if (!hasValidRange) {
    return (
      <Alert severity='info'>
        {isCustom
          ? 'Choose a From and To date to see the metrics.'
          : 'Choose a period to see the metrics.'}
      </Alert>
    )
  }

  return (
    <Grid container spacing={3}>
      {hasError && (
        <Grid item xs={12}>
          <Alert severity='error'>Could not load the negotiation overview metrics.</Alert>
        </Grid>
      )}

      <Grid item xs={12}>
        <NegotiationOverviewHistoryNote start={start} />
      </Grid>

      <Grid item xs={12}>
        <NegotiatedJobsKpiCard data={overviewData} loading={overview.loading && !overviewData} />
      </Grid>

      <Grid item xs={12}>
        <PriceDeltaHistogramCard
          data={histogramData}
          loading={histogram.loading && !histogramData}
        />
      </Grid>

      <Grid item xs={12}>
        <NegotiationOutcomeTiles data={overviewData} loading={overview.loading && !overviewData} />
      </Grid>
    </Grid>
  )
}
